export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - White.6f37d82b.jpg";